"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAccountDeletionRequestDataDto = instanceOfAccountDeletionRequestDataDto;
exports.AccountDeletionRequestDataDtoFromJSON = AccountDeletionRequestDataDtoFromJSON;
exports.AccountDeletionRequestDataDtoFromJSONTyped = AccountDeletionRequestDataDtoFromJSONTyped;
exports.AccountDeletionRequestDataDtoToJSON = AccountDeletionRequestDataDtoToJSON;
exports.AccountDeletionRequestDataDtoToJSONTyped = AccountDeletionRequestDataDtoToJSONTyped;
/**
 * Check if a given object implements the AccountDeletionRequestDataDto interface.
 */
function instanceOfAccountDeletionRequestDataDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
function AccountDeletionRequestDataDtoFromJSON(json) {
    return AccountDeletionRequestDataDtoFromJSONTyped(json, false);
}
function AccountDeletionRequestDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'email': json['email'],
    };
}
function AccountDeletionRequestDataDtoToJSON(json) {
    return AccountDeletionRequestDataDtoToJSONTyped(json, false);
}
function AccountDeletionRequestDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'email': value['email'],
    };
}
